var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 3873 3873",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 656.279,
    x2: 3220.799,
    y1: 421.73,
    y2: 2986.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dbde"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M2054.5 1380.4V794.5h-1771v1187.8h251.8c20.9 0 38.4 14.1 43.7 33.3L724.4 2414l338-413.4c8.3-11.2 21.5-18.4 36.5-18.4h955.5v-601.8zm-212.7 369.9H496.2c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3h1345.5c25 0 45.3 20.3 45.3 45.3s-20.2 45.3-45.2 45.3zm0-316.6H496.2c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3h1345.5c25 0 45.3 20.3 45.3 45.3.1 25-20.2 45.3-45.2 45.3zm0-316.6H496.2c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3h1345.5c25 0 45.3 20.3 45.3 45.3s-20.2 45.3-45.2 45.3zm303.4 308.6v601.8c0 25-20.3 45.3-45.3 45.3h-277.2v540.6h955.6c13.1 0 26.1 5.7 35.1 16.7l339.4 415.1 145.3-398.6c5.3-19.1 22.9-33.1 43.7-33.1h251.9V1425.7zm1235.6 955.9h-972c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3h972c25 0 45.3 20.3 45.3 45.3.1 25-20.2 45.3-45.3 45.3zm0-316.6h-972c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3h972c25 0 45.3 20.3 45.3 45.3s-20.2 45.3-45.3 45.3zm0-316.7h-972c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3h972c25 0 45.3 20.3 45.3 45.3s-20.2 45.3-45.3 45.3z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.2705a8efd10b5e3d868543797f43d64c.svg";
export { ForwardRef as ReactComponent };